import React from 'react';

import clsx from 'clsx';

import TableHead from 'components/Table/TableHead/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell/TableHeadCell';
import TableBody from 'components/Table/TableBody/TableBody';
import Table from 'components/Table/Table';
import TableRow from 'components/Table/TableRow/TableRow';
import TableBodyCell from 'components/Table/TableBodyCell/TableBodyCell';
import { Button } from 'components/Buttons/Button';
import { maskMonetaryValue } from 'utils/stringUtils';
import { OFFERS_TABLE_COLUMNS } from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/OffersTableWrapper/offersTableWrapper.constants';
import { OffersPageFilters } from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/OffersTableWrapper/offersTableWrapper.types';
import { OfferDto } from 'api/AutomatedOffersApi';
import styles from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/OffersTableWrapper/OffersTable/OffersTable.module.scss';
import OfferRowLabel from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/OffersTableWrapper/OfferRowLabel/OfferRowLabel';

export interface OffersTableProps {
  offers: OfferDto[];
  onAcceptOffer: (loanOffer: OfferDto) => void;
  isDisabled: boolean;
  filters: OffersPageFilters;
  updateTableSort: (sortField?: keyof OfferDto) => void;
}

const OffersTable = ({ onAcceptOffer, isDisabled, filters, updateTableSort, offers }: OffersTableProps) => {
  return (
    <Table className={styles.table}>
      <TableHead className={clsx(styles.tableRowTemplate, styles.tableHead)}>
        {OFFERS_TABLE_COLUMNS.map((column) => (
          <TableHeadCell
            key={column.title}
            className={clsx(styles.tableHeadCell, {
              [styles.tableHeadCellSorted]: filters.sortField === column.sortField,
            })}
            isExist={column.isExist}
            isSorted={!!column.sortField}
            currentSort={filters.sortField === column.sortField}
            isSortedDesc={filters.isSortDesc}
            onClick={() => updateTableSort(column.sortField)}
          >
            {column.title}
          </TableHeadCell>
        ))}
      </TableHead>
      <TableBody>
        {offers.map((offer: OfferDto, index) => (
          <TableRow key={index} className={clsx(styles.tableRowTemplate, styles.tableRow)}>
            <TableBodyCell className={styles.tableBodyCell}>{offer.term} years</TableBodyCell>
            <TableBodyCell className={styles.tableBodyCell}>{offer.rate}%</TableBodyCell>
            <TableBodyCell className={styles.tableBodyCell}>{`${offer.apr}%`}</TableBodyCell>
            <TableBodyCell className={styles.tableBodyCell}>{maskMonetaryValue(offer.monthlyPayment)}</TableBodyCell>
            <TableBodyCell className={styles.tableBodyCell}>
              <Button className={styles.acceptButton} disabled={isDisabled} onClick={() => onAcceptOffer(offer)}>
                Accept
              </Button>
            </TableBodyCell>
            <OfferRowLabel offer={offer} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default OffersTable;
